<div *transloco="let transloco" class="flex">
  <p-picklist
    (onMoveAllToSource)="this.onMoveAllToSource($event)"
    (onMoveAllToTarget)="this.onMoveAllToTarget($event)"
    (onMoveToSource)="this.onMoveToSource($event)"
    (onMoveToTarget)="this.onMoveToTarget($event)"
    [dragdrop]="this.dragdrop()"
    [responsive]="true"
    [scrollHeight]="this.scrollHeight()"
    [showSourceControls]="this.showSourceControls()"
    [showSourceFilter]="this.showSourceFilter()"
    [showTargetControls]="this.showTargetControls()"
    [showTargetFilter]="this.showTargetFilter()"
    [source]="this.source()"
    [target]="this.target()"
    appendTo="body"
    class="w-full"
    fluid>
    <ng-template let-item #item>
      {{ transloco(item['label']) }}
    </ng-template>
  </p-picklist>
</div>
